import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';

const didiData = [
  {
    id: 1,
    image: '/images/Artists/DidiFuckboy.jpg',
    link: 'https://open.spotify.com/intl-it/album/4vWnipqN9sM7VyXS3fYH2n',
    title: '"FUCKBOY" OFFICIAL VIDEOCLIP DIDI ',
    description: 'Now single "FUCKBOY" out on Spotify',
  },
  {
    id: 2,
    image: '/images/Artists/DIDI_AmoreEstate.jpg',
    title: '"L\'AMORE D\'ESTATE" OFFICIAL VIDEOCLIP DIDI',
    link: 'https://www.youtube.com/watch?v=i72DMT_gGeA&ab_channel=DIDI',
    description: 'Official Videoclip out on Youtube and Spotify',
  },
  
]


function Didi() {
  return (
    <section className="artists">
      <Container fluid>
        <Row className="g-4 justify-content-center"> {/* Centratura e spaziatura */}
          {didiData.map((item) => (
            <Col xs={12} sm={6} md={4} lg={3} key={item.id}>
              <div className="artists__card">
                <a href={item.link} className="artists__card-link">
                  <div className="artists__card-image">
                    <Image src={item.image} alt={item.title} fluid className="artists__card-img" />
                  </div>
                  <h3 className="artists__card-title">{item.title}</h3>
                  <p className="artists__card-description">{item.description}</p>
                </a>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}
export default Didi;
